import { SITE, whatsappLink } from "@/config/site";
import { ArrowRight, Scale } from "lucide-react";

export const Hero = () => {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative min-h-screen w-full overflow-hidden flex items-center"
    >
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://images.pexels.com/photos/6077665/pexels-photo-6077665.jpeg"
          alt=""
          aria-hidden="true"
          className="w-full h-full object-cover object-center scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#050505] via-[#050505]/90 to-[#050505]/40" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#050505] via-transparent to-[#050505]/60" />
        <div className="absolute inset-0 gold-glow pointer-events-none" />
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 md:px-12 lg:px-16 pt-44 lg:pt-32 pb-24">
        <div className="max-w-3xl">
          <div className="flex items-center gap-3 mb-8 reveal">
            <span className="h-px w-12 bg-[#D4AF37]" />
            <span className="text-xs sm:text-sm tracking-[0.32em] uppercase text-[#D4AF37]">
              Dr. Sandrey Miranda Nobre · CRO 29.826
            </span>
          </div>

          <h1 className="font-serif-display text-3xl sm:text-4xl lg:text-5xl xl:text-6xl text-white leading-[1.1] tracking-tight font-semibold reveal reveal-delay-1">
            Cirurgião-Dentista{" "}
            <span className="text-[#D4AF37]">|</span>{" "}
            <span className="italic text-[#D4AF37]">Perito Judicial Odontológico</span>{" "}
            <span className="text-[#D4AF37]">|</span>{" "}
            Assistente Técnico Judicial
          </h1>

          <p className="mt-8 text-base sm:text-lg text-white/70 max-w-2xl leading-relaxed reveal reveal-delay-2">
            Análises técnicas imparciais para magistrados, advogados, empresas
            e particulares, com rigor científico e compromisso com a verdade
            dos fatos.
          </p>

          <div className="mt-12 flex flex-col sm:flex-row gap-4 reveal reveal-delay-3">
            <a
              href={whatsappLink()}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="hero-cta-primary"
              className="group inline-flex items-center justify-center gap-3 bg-[#D4AF37] text-[#050505] font-medium px-8 py-4 hover:bg-[#F0C950] transition-all duration-300"
            >
              Solicitar Perícia
              <ArrowRight
                size={18}
                className="group-hover:translate-x-1 transition-transform"
              />
            </a>
            <a
              href="#servicos"
              data-testid="hero-cta-secondary"
              className="inline-flex items-center justify-center gap-3 border border-[#D4AF37]/60 text-[#D4AF37] px-8 py-4 hover:bg-[#D4AF37]/10 transition-colors duration-300"
            >
              Conhecer Serviços
            </a>
          </div>

          {/* Trust strip */}
          <div className="mt-20 grid grid-cols-3 gap-6 sm:gap-12 max-w-2xl reveal reveal-delay-4">
            {[
              { k: "07", v: "Pós-graduações em Odontologia" },
              { k: "100%", v: "Imparcialidade técnica" },
              { k: "24h", v: "Atendimento por WhatsApp" },
            ].map((item, i) => (
              <div key={i} className="border-l border-[#D4AF37]/30 pl-4">
                <div className="font-serif-display text-2xl sm:text-3xl text-[#D4AF37]">
                  {item.k}
                </div>
                <div className="mt-1 text-xs sm:text-sm text-white/60 leading-snug">
                  {item.v}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Floating scales icon (decorative) */}
      <div className="hidden lg:block absolute right-12 bottom-12 z-10 opacity-30">
        <Scale size={120} strokeWidth={1} className="text-[#D4AF37]" />
      </div>

      {/* Bottom hairline */}
      <div className="absolute bottom-0 left-0 right-0 h-px gold-line opacity-50" />
    </section>
  );
};
